<template>
  <v-card>
    <v-toolbar color="#1B5E20" max-width="1200" class="mx-auto" elevation="0">
      <v-btn
        icon
        dark
        @click.native="close"
        color="white"
        elevation="0"
        class="white--text"
        large
      >
        <v-icon>mdi-close</v-icon>
      </v-btn>

      <v-text-field
        label="Search"
        class="mt-5"
        filled
        append-icon="mdi-magnify"
        dense
        solo
        flat
        v-model="keyword"
        @input="doSearch"
        icon
        rounded
        color="white"
        outlined
        elevation="5"
        large
      >
      </v-text-field>
    </v-toolbar>
    <v-card-text>
      <v-subheader v-if="keyword.length > 0"> Result search "{{ keyword }}" </v-subheader>

      <v-alert :value="products.length == 0 && keyword.length > 0" color="warning">
        Sorry, but no results were found.
      </v-alert>

      <!-- Hasil pencarian ditampilkan di sini -->
      <v-container class="ma-0 pa-0" grid-list-sm>
        <v-layout wrap>
          <v-flex v-for="product in products" :key="`product-` + product.id" xs6>
            <product-item :product="product" @click.native="close" />
          </v-flex>
        </v-layout>
      </v-container>
    </v-card-text>
  </v-card>
</template>
<script>
export default {
  name: "search",
  components: {
    ProductItem: () =>
      import(/* webpackChunkName: "product-item" */ "@/components/ProductItem.vue"),
  },
  data() {
    return {
      keyword: "",
      products: [],
    };
  },
  methods: {
    doSearch() {
      let keyword = this.keyword;
      if (keyword.length > 0) {
        this.axios
          .get("/ecommerce-products/search/" + keyword)
          .then((response) => {
            let { data } = response.data;
            this.products = data;
          })
          .catch((error) => {
            console.log(error);
          });
      } else {
        this.products = [];
      }
    },
    close() {
      this.$emit("closed", false);
    },
  },
};
</script>
